module.exports = ".custom-account-lookup>.ng-select-disabled::ng-deep .ng-value-label{color:black !important}\n"